import { star } from "icons/index";

export const FILTERS = [
	{ key: "all", label: "All Categories" },
	{ key: "favourite", label: "Favourite", icon: star },
	{ key: "new", label: "New" },
	{ key: "event", label: "Events" },
];
